import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchHistory,
  updateStatAttribute,
  updateQuiz,
  setCurrent,
  updateNotesFlagged
} from '../actions/index';
import { HELPERS, ASSET_PREFIX } from '../config/constants';

import SvgIcon from 'material-ui/SvgIcon';

import '../styles/QuestionHeader.css';

class QuestionHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      flaggedHoverReset: false
    };
    this.onFlag = this.onFlag.bind(this);
  }

  onFlag() {
    const {
      fetchHistory,
      updateStatAttribute,
      updateQuiz,
      flagged,
      currentQuestionIndex,
      setCurrent,
      updateNotesFlagged,
      question
    } = this.props;
    updateStatAttribute({ flagged: !flagged }).then(() => {
      fetchHistory();
      updateQuiz(
        HELPERS.UPDATE_OBJECT({ flagged: !flagged }, currentQuestionIndex)
      );
      updateNotesFlagged(question, false, !flagged);
    });
    setCurrent();
  }

  render() {
    const {
      currentQuestionIndex,
      count,
      flagged,
      viewOnly,
      editingNotes
    } = this.props;
    const hoverColor =
      ASSET_PREFIX[this.props.product] === 'EM'
        ? '#FF7065'
        : 'PA' ? '#5E95CF' : '#AF60DA';

    return (
      <div className="question-header">
        {/*TESTING STATS FOR DIFF:*/}
        {/*<strong>QUESTION - Correct: {this.props.question.correctCount} Total: {this.props.question.totalCount} Difficulty: {Math.round((1 - (this.props.question.correctCount / this.props.question.totalCount)) * 10000) / 10000}</strong>*/}
        {/*<strong>*/}
        {/*QUIZ - Mean: {Math.round(this.props.questions.map(o => 1 - (o.correctCount / o.totalCount)).reduce((a, o) => a + o, 0) / this.props.questions.length * 10000) / 10000} Sdev: {Math.round(Math.sqrt(this.props.questions.map(o => (1 - o.correctCount / o.totalCount)).map(o => Math.pow(o - Math.round(this.props.questions.map(o => 1 - (o.correctCount / o.totalCount)).reduce((a, o) => a + o, 0) / this.props.questions.length * 10000) / 10000, 2)).reduce((a, o) => a + o, 0) / this.props.questions.map(o => (1 - o.correctCount / o.totalCount)).length) * 10000) / 10000}*/}
        {/*</strong>*/}
        {/*<strong>OVERALL - Mean: {this.props.question.TEST_ONLY_REMOVE_ME.MEAN} Median: {this.props.question.TEST_ONLY_REMOVE_ME.MEDIAN} Range: {this.props.question.TEST_ONLY_REMOVE_ME.RANGE[0]} - {this.props.question.TEST_ONLY_REMOVE_ME.RANGE[1]} Sdev: {this.props.question.TEST_ONLY_REMOVE_ME.SDEV}</strong>*/}
        <div className="header-row">
          <p className="header-progress">
            {viewOnly ? 'QUESTION' : `QUESTION ${currentQuestionIndex + 1}`}
            {!viewOnly ? <span>{` / ${count}`}</span> : null}
          </p>
          <div className="header-icons">
            <div className="question-header-icon lab-stats-icon">
              <SvgIcon
                color="#A1A0A0"
                hoverColor={hoverColor}
                onClick={() =>
                  window.open(
                    'http://www.nbme.org/pdf/SubjectExams/LabReferenceValues.pdf'
                  )
                }
              >
                <path
                  d="M21.8596556,20.4460547 L15.429389,7.80232704 L15.429389,2.26436239 L16.5265239,2.26436239 L16.5265239,0.0289084181 L5.52583969,0.0289084181 L5.52583969,2.26436239 L6.62884163,2.26436239 L6.62884163,7.80232704 L0.198575015,20.4460547 C-0.259053449,21.2865854 0.263112362,22.3834482 1.13143304,22.3834482 L20.9267976,22.3834482 C21.7951183,22.3834482 22.3172841,21.2865854 21.8596556,20.4460547 Z M5.74878689,14.5563787 L8.82311144,8.42825415 L8.82311144,2.26436239 L13.2233851,2.26436239 L13.2233851,8.42825415 L16.2977097,14.5623399 L5.74878689,14.5623399 L5.74878689,14.5563787 Z"
                  id="Shape"
                />
                <ellipse
                  id="Oval"
                  cx="11.7619346"
                  cy="11.9507401"
                  rx="1.06409375"
                  ry="1.08117484"
                />
                <ellipse
                  id="Oval"
                  cx="10.6978409"
                  cy="5.64292322"
                  rx="1.06409375"
                  ry="1.08117484"
                />
              </SvgIcon>
            </div>
            <div className="question-header-icon notes-icon">
              <SvgIcon
                color={`${editingNotes ? hoverColor : '#A1A0A0'}`}
                hoverColor={`${editingNotes ? '#A1A0A0' : hoverColor}`}
                style={{ height: '29px' }}
                viewBox="0 0 27 29"
                onClick={() =>
                  this.props.updateQuiz(
                    HELPERS.UPDATE_OBJECT(
                      { editingNotes: !editingNotes },
                      currentQuestionIndex
                    )
                  )
                }
              >
                <path
                  d="M6.83038966,4.36034793 L13.3782898,4.36034793 L13.3782898,1.98614258 L6.83038966,1.98614258 L6.83038966,4.36034793 Z M14.2929542,6.21519586 L5.91572517,6.21519586 C5.41083038,6.21519586 5.00106069,5.8000809 5.00106069,5.2877719 L5.00106069,1.05871861 C5.00106069,0.546409615 5.41083038,0.131294648 5.91572517,0.131294648 L14.2929542,0.131294648 C14.7982149,0.131294648 15.2076187,0.546409615 15.2076187,1.05871861 L15.2076187,5.2877719 C15.2076187,5.8000809 14.7982149,6.21519586 14.2929542,6.21519586 L14.2929542,6.21519586 Z"
                  id="Fill-3"
                  mask="url(#mask-2)"
                />
                <path
                  d="M9.04395088,25.2459356 L1.7449283,25.2459356 C1.23966764,25.2459356 0.83026382,24.8308207 0.83026382,24.3185117 L0.83026382,3.17324526 C0.83026382,2.66093626 1.23966764,2.24582129 1.7449283,2.24582129 L5.91579835,2.24582129 C6.42105901,2.24582129 6.83046283,2.66093626 6.83046283,3.17324526 L6.83046283,4.36034793 L13.342874,4.36034793 L13.342874,3.17324526 C13.342874,2.66093626 13.7522778,2.24582129 14.2575384,2.24582129 L18.4284085,2.24582129 C18.9336691,2.24582129 19.343073,2.66093626 19.343073,3.17324526 L19.343073,11.6313518 C19.343073,12.1436608 18.9336691,12.5587758 18.4284085,12.5587758 C17.9231478,12.5587758 17.513744,12.1436608 17.513744,11.6313518 L17.513744,4.10066922 L15.1722029,4.10066922 L15.1722029,5.2877719 C15.1722029,5.8000809 14.7627991,6.21519586 14.2575384,6.21519586 L5.91579835,6.21519586 C5.41053769,6.21519586 5.00113386,5.8000809 5.00113386,5.2877719 L5.00113386,4.10066922 L2.65959279,4.10066922 L2.65959279,23.3910877 L9.04395088,23.3910877 C9.54921154,23.3910877 9.95861536,23.8062027 9.95861536,24.3185117 C9.95861536,24.8308207 9.54921154,25.2459356 9.04395088,25.2459356"
                  id="Fill-5"
                  mask="url(#mask-2)"
                />
                <path
                  d="M14.9329999,21.6199305 L14.5517677,22.9632114 L15.8762019,22.5762901 L21.6309049,16.7420514 L20.6869712,15.7849499 L14.9329999,21.6199305 Z M13.21526,25.2461582 C12.9759837,25.2461582 12.7425614,25.15119 12.5684092,24.9746085 C12.3331575,24.736075 12.2438863,24.3866217 12.3360845,24.0623943 L13.2405047,20.8768784 C13.2829451,20.7262648 13.3630697,20.5886351 13.4724636,20.4777152 L19.4847362,14.380459 C20.1473192,13.7082622 21.2258915,13.7082622 21.8888403,14.380459 L23.0160728,15.5234163 C23.6786558,16.1952423 23.6786558,17.2888606 23.0160728,17.9606865 L17.0027027,24.0568297 C16.8933088,24.1681206 16.7579384,24.248992 16.6093969,24.2923954 L13.4684391,25.2101742 C13.3850217,25.2342872 13.299775,25.2461582 13.21526,25.2461582 Z"
                  id="Fill-1"
                  mask="url(#mask-2)"
                />
                <path
                  d="M14.2575384,10.4441008 L5.91579835,10.4441008 C5.41053769,10.4441008 5.00113386,10.0289858 5.00113386,9.5166768 C5.00113386,9.0043678 5.41053769,8.58925283 5.91579835,8.58925283 L14.2575384,8.58925283 C14.7627991,8.58925283 15.1722029,9.0043678 15.1722029,9.5166768 C15.1722029,10.0289858 14.7627991,10.4441008 14.2575384,10.4441008"
                  id="Fill-6"
                  mask="url(#mask-2)"
                />
                <path
                  d="M14.2575384,14.6733024 L5.91579835,14.6733024 C5.41053769,14.6733024 5.00113386,14.2581875 5.00113386,13.7458785 C5.00113386,13.2335695 5.41053769,12.8184545 5.91579835,12.8184545 L14.2575384,12.8184545 C14.7627991,12.8184545 15.1722029,13.2335695 15.1722029,13.7458785 C15.1722029,14.2581875 14.7627991,14.6733024 14.2575384,14.6733024"
                  id="Fill-7"
                  mask="url(#mask-2)"
                />
                <path
                  d="M12.1720302,18.9021331 L5.91572517,18.9021331 C5.41046451,18.9021331 5.00106069,18.4870182 5.00106069,17.9747092 C5.00106069,17.4627711 5.41046451,17.0472852 5.91572517,17.0472852 L12.1720302,17.0472852 C12.6772909,17.0472852 13.0866947,17.4627711 13.0866947,17.9747092 C13.0866947,18.4870182 12.6772909,18.9021331 12.1720302,18.9021331"
                  id="Fill-8"
                  mask="url(#mask-2)"
                />
              </SvgIcon>
            </div>
            <div
              onMouseLeave={() =>
                this.state.flaggedHoverReset
                  ? this.setState({ flaggedHoverReset: false })
                  : null
              }
              onClick={() => {
                this.setState({ flaggedHoverReset: true });
                this.onFlag();
              }}
              className="question-header-icon flagged-icon"
            >
              <SvgIcon
                color={`${flagged ? hoverColor : '#A1A0A0'}`}
                hoverColor={`${
                  flagged
                    ? this.state.flaggedHoverReset ? hoverColor : '#A1A0A0'
                    : this.state.flaggedHoverReset ? '#A1A0A0' : hoverColor
                }`}
              >
                <path
                  d="M6,2 L6,25.4375 L13.3243108,18.1131892 L20.6482534,25.4375 L20.6482534,2 L6,2 Z M8.20955628,4.20955628 L18.4386971,4.20955628 L18.4386971,20.1032629 L14.8868354,16.5510329 L13.3243108,14.9885083 L11.7617863,16.5510329 L8.20955628,20.1032629 L8.20955628,4.20955628 Z"
                  id="Page-1"
                />
              </SvgIcon>
            </div>
            {/* UNTIL 1.x
              <div className="question-header-icon hide-on-mobile key-shorts-icon">
                <SvgIcon color="#A1A0A0"
                  hoverColor="#EB5342"
                  onClick={() => console.log('DISPLAY KEY SHORTS')}
                  style={{ width: '37px' }}
                  viewBox="0 0 34 27">
                  <polygon id="Fill-1"
                    points="4.55398777 7.19304153 6.65722706 7.19304153 6.65722706 5.14057239 4.55398777 5.14057239"></polygon>
                  <polygon id="Fill-2"
                    points="9.02754435 7.19304153 11.1307836 7.19304153 11.1307836 5.14057239 9.02754435 5.14057239"></polygon>
                  <polygon id="Fill-3"
                    points="13.4677162 7.19304153 15.5709555 7.19304153 15.5709555 5.14057239 13.4677162 5.14057239"></polygon>
                  <polygon id="Fill-4"
                    points="17.907888 7.19304153 20.0111273 7.19304153 20.0111273 5.14057239 17.907888 5.14057239"></polygon>
                  <polygon id="Fill-5"
                    points="22.3814446 7.19304153 24.4846839 7.19304153 24.4846839 5.14057239 22.3814446 5.14057239"></polygon>
                  <polygon id="Fill-6"
                    points="26.8216164 7.19304153 28.9248557 7.19304153 28.9248557 5.14057239 26.8216164 5.14057239"></polygon>
                  <polygon id="Fill-7"
                    points="4.55398777 11.5586108 6.65722706 11.5586108 6.65722706 9.50614166 4.55398777 9.50614166"></polygon>
                  <polygon id="Fill-8"
                    points="4.55398777 15.8916012 6.65722706 15.8916012 6.65722706 13.8391321 4.55398777 13.8391321"></polygon>
                  <polygon id="Fill-9"
                    points="9.02754435 11.5586108 11.1307836 11.5586108 11.1307836 9.50614166 9.02754435 9.50614166"></polygon>
                  <polygon id="Fill-10"
                    points="9.02754435 15.8916012 24.4846839 15.8916012 24.4846839 13.8391321 9.02754435 13.8391321"></polygon>
                  <polygon id="Fill-11"
                    points="13.4677162 11.5586108 15.5709555 11.5586108 15.5709555 9.50614166 13.4677162 9.50614166"></polygon>
                  <polygon id="Fill-12"
                    points="17.907888 11.5586108 20.0111273 11.5586108 20.0111273 9.50614166 17.907888 9.50614166"></polygon>
                  <polygon id="Fill-13"
                    points="22.3814446 11.5586108 24.4846839 11.5586108 24.4846839 9.50614166 22.3814446 9.50614166"></polygon>
                  <polygon id="Fill-14"
                    points="26.8216164 11.5586108 28.9248557 11.5586108 28.9248557 9.50614166 26.8216164 9.50614166"></polygon>
                  <polygon id="Fill-15"
                    points="26.8216164 15.8916012 28.9248557 15.8916012 28.9248557 13.8391321 26.8216164 13.8391321"></polygon>
                  <path d="M2.28382473,18.1069647 L31.2284035,18.1069647 L31.2284035,2.92520888 L2.28382473,2.92520888 L2.28382473,18.1069647 Z M32.3301003,20.2897493 L1.1487432,20.2897493 C0.547817694,20.2897493 0.0470464342,19.8010662 0.0470464342,19.2146465 L0.0470464342,1.81752712 C0.0470464342,1.23110737 0.547817694,0.742424242 1.1487432,0.742424242 L32.2967155,0.742424242 C32.8976411,0.742424242 33.3984123,1.23110737 33.3984123,1.81752712 L33.3984123,19.1820676 C33.4317971,19.8010662 32.9310258,20.2897493 32.3301003,20.2897493 L32.3301003,20.2897493 Z"
                    id="Fill-16"></path>
                </SvgIcon>
              </div>
              */}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const question = state.quiz.questions[state.quiz.currentQuestionIndex];

  return {
    // questions: state.quiz.questions,//TODO: REMOVE AFTER TESTING
    product: state.app.product,
    question,
    editingNotes: question.editingNotes,
    currentQuestionIndex: state.quiz.currentQuestionIndex,
    count: state.quiz.questions.length,
    flagged: question.flagged,
    viewOnly: state.quiz.viewOnly
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchHistory,
      updateQuiz,
      updateStatAttribute,
      setCurrent,
      updateNotesFlagged
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionHeader);



// WEBPACK FOOTER //
// ./src/containers/QuestionHeader.js